module.exports = __webpack_public_path__ + "media/images/cancellation-success-8edb75489f1a630f05b9032369bb2344.svg";